export function cartUpdate (data) {
  const token = document
    .querySelector('meta[name="csrf-token"]')
    .getAttribute('content')

  fetch('/cart', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': token
    },
    body: JSON.stringify(data)
  })
    .then(response => {
      return response.json()
    })
    .then(result => {
      // update counter in menu via js
      document.querySelector('#cart_badge .badge').innerHTML =
        result.number_of_items

      // update menu class for when cart is set to 1
      if (result.number_of_items == 1) {
        var cartElement = document.querySelector('#cart_badge')
        cartElement.classList.remove('is-hidden')
      }
    })
}
